export const NAMESPACE = "Notifications";
export const INSTANCE_ID = "header-notification-instance";
